export default __webpack_public_path__ + "static/media/nofilter.52deb1e6.svg";